module.exports = __webpack_public_path__ + "img/emptyprivilage.b4815d7c.svg";